import { Check } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

export const Hovedentreprenoerer = () => {
  return (
    <>
      <SEO
        title="Kloakpartner for hovedentreprenører"
        description="Farum Kloak samarbejder med hovedentreprenører om kloak- og anlægsopgaver. Faglig sparring, hurtig respons og dokumentation – fra tilbud til færdigt resultat."
      />
      <PageHero
        eyebrow="Segment · Hovedentreprenører"
        title={
          <>
            Kloakpartneren, der <em className="text-[color:var(--fk-gold)]">tænker med på pladsen.</em>
          </>
        }
        subtitle="Farum Kloak hjælper hovedentreprenører med kloakopgaver, hvor faglig sparring, hurtig respons og sikker udførelse skal hænge sammen. Vi planlægger med, koordinerer med de øvrige fag og står på mål for det færdige resultat."
        image={ASSETS.images.contractor}
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-display text-2xl md:text-3xl leading-snug italic text-white/95">
              Når kloakarbejdet er en del af en større byggeplads, skal
              samarbejdet fungere. Vi møder ind med faglighed, overblik og
              respekt for tidsplanen.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="eyebrow mb-6">Det får du</div>
            <ul className="space-y-5">
              {[
                "Høj faglig ekspertise inden for kloak, afvanding og fejlfinding",
                "Sparring i både tilbuds-, planlægnings- og udførelsesfasen",
                "Folk på pladsen, der kan tænke selv og reagere hurtigt",
                "Fælles fokus på løsning, fremdrift og koordinering med øvrige fag",
                "Klar afrapportering, kvalitetssikring og dokumentation",
              ].map((b, i) => (
                <li key={i} className="flex gap-4 text-lg text-white/80 font-light border-b border-white/10 pb-5">
                  <Check className="w-5 h-5 flex-shrink-0 mt-1.5 text-[color:var(--fk-gold)]" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Capabilities */}
      <section className="border-t border-white/10 bg-[color:var(--fk-bg-2)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
            <div className="md:col-span-5">
              <div className="eyebrow mb-4">Kapacitet</div>
              <h2 className="font-display text-4xl md:text-5xl leading-tight">
                Det bidrager vi med.
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
            {[
              { title: "Anlæg", body: "Etablering, renovering og omlægning af kloak, brønde og afvanding i både nye og eksisterende projekter." },
              { title: "Sparring", body: "Faglig vurdering i tilbuds-, planlægnings- og udførelsesfasen, så løsningen passer til virkeligheden på pladsen." },
              { title: "Drift", body: "Service, vedligehold og opfølgning efter aflevering, så kloakken fungerer stabilt, når projektet er i brug." },
            ].map((c, i) => (
              <div key={i} className="bg-[color:var(--fk-bg-2)] p-10 md:p-14">
                <div className="eyebrow mb-6 text-[color:var(--fk-gold)]">0{i + 1}</div>
                <h3 className="font-display text-2xl md:text-3xl mb-4">{c.title}</h3>
                <p className="text-white/60 font-light">{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="eyebrow mb-6">Næste skridt</div>
            <h2 className="font-display text-4xl md:text-5xl leading-tight">
              Skal vi tale om <em className="text-[color:var(--fk-gold)]">næste projekt?</em>
            </h2>
            <p className="mt-6 text-white/60 font-light max-w-xl">
              Ring eller skriv til os, hvis I har brug for en kloakpartner til
              tilbud, planlægning eller udførelse. Vi tager dialogen tidligt,
              så løsningen kan tænkes ordentligt ind fra start.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col sm:flex-row gap-4">
            <a href={ASSETS.brand.phoneTel} className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase bg-[color:var(--fk-gold)] text-black hover:bg-[color:var(--fk-gold-hi)] transition-colors text-center">
              Ring {ASSETS.brand.phone}
            </a>
            <a href={`mailto:${ASSETS.brand.email}`} className="px-7 py-4 text-[11px] tracking-[0.24em] uppercase border border-white/20 hover:border-[color:var(--fk-gold)] hover:text-[color:var(--fk-gold)] transition-colors text-center">
              Skriv til os
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
